import { Routes } from '@angular/router';
import { AuthGuard } from './core/guards/auth.guard';
import { GuestGuard } from './core/guards/guest.guard';
import { RoleGuard } from './core/guards/role.guard';
import { AuthLayoutComponent } from './shared/components/templates/auth-layout/auth-layout.component';
import { MainLayoutComponent } from './shared/components/templates/main-layout/main-layout.component';
import { UserRole } from './shared/enums/userRole.enum';

export const routes: Routes = [
  {
    path: '',
    component: AuthLayoutComponent,
    children: [
      {
        path: '',
        loadComponent: () =>
          import('./shared/components/pages/landing-page/landing-page.component').then((m) => m.LandingPageComponent),
        pathMatch: 'full',
        canActivate: [GuestGuard],
        data: { title: 'titles.landing', description: 'meta.landing.description' },
      },
      // {
      //   path: 'register',
      //   loadComponent: () =>
      //     import('./shared/components/pages/register/register.component').then((m) => m.RegisterComponent),
      //   canActivate: [GuestGuard],
      //   data: { title: 'titles.register', description: 'meta.default.description' },
      // },
      {
        path: 'login',
        loadComponent: () =>
          import('./shared/components/pages/login/login.component').then((m) => m.LoginComponent),
        canActivate: [GuestGuard],
        data: { title: 'titles.login', description: 'meta.default.description' },
      },
      {
        path: 'privacy-policy',
        loadComponent: () =>
          import('./shared/components/pages/privacy-policy-page/privacy-policy-page.component').then((m) => m.PrivacyPolicyPageComponent),
        canActivate: [GuestGuard],
        data: { title: 'titles.privacyPolicy', description: 'meta.default.description' },
      },
      {
        path: 'terms-and-conditions',
        loadComponent: () =>
          import('./shared/components/pages/terms-and-conditions-page/terms-and-conditions-page.component').then((m) => m.TermsAndConditionsPageComponent),
        canActivate: [GuestGuard],
        data: { title: 'titles.terms', description: 'meta.default.description' },
      },
      {
        path: 'verify-email',
        loadComponent: () =>
          import('./shared/components/pages/verify-email/verify-email.component').then((m) => m.VerifyEmailComponent),
        canActivate: [GuestGuard],
        data: { title: 'titles.verify_email', description: 'meta.default.description' },
      },
      {
        path: 'verify-email-sent',
        loadComponent: () =>
          import('./shared/components/pages/verify-email-sent/verify-email-sent.component').then((m) => m.VerifyEmailSentComponent),
        canActivate: [GuestGuard],
        data: { title: 'titles.verify_email_sent', description: 'meta.default.description' },
      },
      {
        path: 'confirm-email-change',
        loadComponent: () =>
          import('./shared/components/pages/confirm-email-change/confirm-email-change.component').then((m) => m.ConfirmEmailChangeComponent),
        data: { title: 'titles.confirm_email_change', description: 'meta.default.description' },
      },
      {
        path: 'forgot-password',
        loadComponent: () =>
          import('./shared/components/pages/forgot-password/forgot-password.component').then(m => m.ForgotPasswordComponent),
        canActivate: [GuestGuard],
        data: { title: 'titles.forgot_password', description: 'meta.default.description' },
      },
      {
        path: 'reset-password',
        loadComponent: () =>
          import('./shared/components/pages/reset-password/reset-password.component').then(m => m.ResetPasswordComponent),
        canActivate: [GuestGuard],
        data: { title: 'titles.reset_password', description: 'meta.default.description' },
      },
      {
        path: 'download',
        loadComponent: () =>
          import('./shared/components/pages/download-page/download-page.component').then((m) => m.DownloadPageComponent),
        canActivate: [GuestGuard],
        data: { title: 'titles.download', description: 'meta.download.description' },
      },
      {
        path: 'app/help-center',
        canActivate: [GuestGuard],
        data: { title: 'titles.helpCenter', description: 'meta.helpCenter.description' },
        loadComponent: () => import('./shared/components/pages/help-center-page/help-center-page.component').then((m) => m.HelpCenterPageComponent),
      },
    ]
  },
  {
    path: '',
    component: MainLayoutComponent,
    children: [
      {
        path: 'home',
        canActivate: [AuthGuard, RoleGuard],
        data: { roles: [UserRole.Admin], title: 'titles.home', description: 'meta.default.description' },
        loadComponent: () => import('./shared/components/pages/overview-page/overview-page.component').then((m) => m.OverviewPageComponent),
      },
      {
        path: 'meal-planner',
        canActivate: [AuthGuard],
        data: { title: 'titles.mealPlanner', description: 'meta.default.description' },
        loadComponent: () => import('./shared/components/pages/meal-planner-page/meal-planner-page.component').then((m) => m.MealPlannerPageComponent),
      },
      {
        path: 'recipes',
        canActivate: [AuthGuard],
        data: { title: 'titles.recipes', description: 'meta.default.description' },
        children: [
          {
            path: '',
            loadComponent: () =>
              import('./shared/components/pages/recipes-page/recipes-page.component').then((m) => m.RecipesPageComponent)
          },
          {
            path: 'not-found',
            data: { title: 'titles.recipeNotFound', description: 'meta.default.description' },
            loadComponent: () =>
              import('./shared/components/pages/recipe-not-found/recipe-not-found.component').then((m) => m.RecipeNotFoundComponent)
          },
          {
            path: ':slug',
            data: { title: 'titles.recipeDetails', description: 'meta.default.description' },
            loadComponent: () =>
              import('./shared/components/pages/recipe-detail-page/recipe-detail-page.component').then((m) => m.RecipeDetailPageComponent)
          },
        ]
      },
      {
        path: 'my-recipes',
        canActivate: [AuthGuard, RoleGuard],
        data: { roles: [UserRole.Admin, UserRole.Moderator, UserRole.Contributor], title: 'titles.myRecipes', description: 'meta.default.description' },
        children: [
          {
            path: '',
            loadComponent: () =>
              import('./shared/components/pages/my-recipes-page/my-recipes-page.component').then((m) => m.MyRecipesPageComponent)
          },
          {
            path: 'add-recipe',
            data: { title: 'titles.addRecipe', description: 'meta.default.description' },
            loadComponent: () =>
              import('./shared/components/pages/recipe-form-page/recipe-form-page.component').then((m) => m.RecipeFormPageComponent)
          },
          {
            path: ':slug/edit-recipe',
            data: { title: 'titles.editRecipe', description: 'meta.default.description' },
            loadComponent: () =>
              import('./shared/components/pages/recipe-form-page/recipe-form-page.component').then((m) => m.RecipeFormPageComponent)
          },
        ]
      },
      {
        path: 'pending',
        canActivate: [AuthGuard, RoleGuard],
        data: { roles: [UserRole.Admin], title: 'titles.pending', description: 'meta.default.description' },
        children: [
          {
            path: '',
            loadComponent: () =>
              import('./shared/components/pages/pending-recipes-page/pending-recipes-page.component').then((m) => m.PendingRecipesPageComponent)
          },
        ]
      },
      {
        path: 'feedbacks',
        canActivate: [AuthGuard, RoleGuard],
        data: { roles: [UserRole.Admin, UserRole.Moderator], title: 'titles.feedbacks', description: 'meta.default.description' },
        children: [
          {
            path: '',
            loadComponent: () =>
              import('./shared/components/pages/feedback-page/feedback-page.component').then((m) => m.FeedbackPageComponent)
          },
        ]
      },
      {
        path: 'recipe-photo-moderation',
        canActivate: [AuthGuard, RoleGuard],
        data: { roles: [UserRole.Admin, UserRole.Moderator], title: 'titles.recipePhotoModeration', description: 'meta.default.description' },
        loadComponent: () =>
          import('./shared/components/pages/recipe-photo-moderation-page/recipe-photo-moderation-page.component').then((m) => m.RecipePhotoModerationPageComponent),
      },
      {
        path: 'announcements',
        canActivate: [AuthGuard, RoleGuard],
        data: { roles: [UserRole.Admin], title: 'titles.announcements', description: 'meta.default.description' },
        children: [
          {
            path: '',
            loadComponent: () =>
              import('./shared/components/pages/announcement-page/announcement-page.component').then((m) => m.AnnouncementPageComponent)
          },
        ]
      },
      {
        path: 'saved-recipes',
        canActivate: [AuthGuard],
        data: { title: 'titles.savedRecipes', description: 'meta.default.description' },
        children: [
          {
            path: '',
            loadComponent: () =>
              import('./shared/components/pages/saved-recipes-page/saved-recipes-page.component').then((m) => m.SavedRecipesPageComponent)
          },
        ]
      },
      {
        path: 'users',
        canActivate: [AuthGuard],
        children: [
          // redirect /users → /recipes (or any page you prefer)
          {
            path: '',
            pathMatch: 'full',
            redirectTo: '/recipes' // or '/home' or '/users/not-found'
          },
          // user not found route
          {
            path: 'not-found',
            loadComponent: () =>
              import('./shared/components/pages/user-not-found-page/user-not-found-page.component').then(
                m => m.UserNotFoundPageComponent
              ),
            data: { title: 'titles.userNotFound', description: 'meta.default.description' }
          },
          // per-user pages
          {
            path: ':username',
            children: [
              {
                path: '',
                pathMatch: 'full',
                redirectTo: 'recipes'
              },
              {
                path: 'recipes',
                data: { title: 'titles.userRecipes', description: 'meta.default.description' },
                children: [
                  {
                    path: '',
                    loadComponent: () =>
                      import('./shared/components/pages/user-recipes-page/user-recipes-page.component').then(
                        m => m.UserRecipesPageComponent
                      )
                  },
                ]
              }
            ]
          }
        ]
      },
      {
        path: 'ingredients',
        canActivate: [AuthGuard, RoleGuard],
        data: { roles: [UserRole.Admin, UserRole.Moderator], title: 'titles.ingredients', description: 'meta.default.description' },
        loadComponent: () => import('./shared/components/pages/ingredients-page/ingredients-page.component').then((m) => m.IngredientsPageComponent),
      },
      {
        path: 'leftovers',
        canActivate: [AuthGuard, RoleGuard],
        data: { roles: [UserRole.Admin, UserRole.Moderator], title: 'titles.leftovers', description: 'meta.default.description' },
        loadComponent: () => import('./shared/components/pages/leftovers-page/leftovers-page.component').then((m) => m.LeftoversPageComponent),
      },
      {
        path: 'household',
        canActivate: [AuthGuard],
        data: { title: 'titles.household', description: 'meta.default.description' },
        loadComponent: () => import('./shared/components/pages/storage-page/storage-page.component').then((m) => m.StoragePageComponent),
      },
      {
        path: 'shopping-list',
        canActivate: [AuthGuard],
        data: { title: 'titles.shoppingList', description: 'meta.default.description' },
        loadComponent: () => import('./shared/components/pages/shopping-list-page/shopping-list-page.component').then((m) => m.ShoppingListPageComponent),
      },
      {
        path: 'admin/dashboard',
        canActivate: [AuthGuard, RoleGuard],
        data: { roles: [UserRole.Admin], title: 'titles.adminDashboard', description: 'meta.default.description' },
        loadComponent: () => import('./shared/components/pages/admin-dashboard/admin-dashboard.component').then((m) => m.AdminDashboardComponent),
      },
      {
        path: 'admin',
        canActivate: [AuthGuard, RoleGuard],
        data: { roles: [UserRole.Admin], title: 'titles.admin', description: 'meta.default.description' },
        loadComponent: () => import('./shared/components/pages/admin/admin.component').then((m) => m.AdminPageComponent),
      },
      {
        path: 'settings',
        canActivate: [AuthGuard],
        data: { title: 'titles.settings', description: 'meta.default.description' },
        loadComponent: () => import('./shared/components/pages/settings-page/settings-page.component').then((m) => m.SettingsPageComponent),
      },
      {
        path: 'profile',
        canActivate: [AuthGuard],
        data: { title: 'titles.profile', description: 'meta.default.description' },
        loadComponent: () => import('./shared/components/pages/profile-page/profile-page.component').then((m) => m.ProfilePageComponent),
      },
      {
        path: 'privacy',
        canActivate: [AuthGuard],
        data: { title: 'titles.privacyPolicy', description: 'meta.default.description' },
        loadComponent: () => import('./shared/components/pages/privacy-policy-page/privacy-policy-page.component').then((m) => m.PrivacyPolicyPageComponent),
      },
      {
        path: 'terms',
        canActivate: [AuthGuard],
        data: { title: 'titles.terms', description: 'meta.default.description' },
        loadComponent: () => import('./shared/components/pages/terms-and-conditions-page/terms-and-conditions-page.component').then((m) => m.TermsAndConditionsPageComponent),
      },
      {
        path: 'help-center',
        canActivate: [AuthGuard],
        data: { title: 'titles.helpCenter', description: 'meta.helpCenter.description' },
        loadComponent: () => import('./shared/components/pages/help-center-page/help-center-page.component').then((m) => m.HelpCenterPageComponent),
      },
      {
        path: 'help',
        canActivate: [AuthGuard],
        data: { title: 'titles.help', description: 'meta.default.description' },
        loadComponent: () => import('./shared/components/pages/help-page/help-page.component').then((m) => m.HelpPageComponent),
      },
      {
        path: 'release-notes',
        canActivate: [AuthGuard],
        data: { title: 'titles.releaseNotes', description: 'meta.default.description' },
        loadComponent: () => import('./shared/components/pages/release-notes/release-notes.component').then((m) => m.ReleaseNotesComponent),
      },
      {
        path: 'ingredient-associations',
        canActivate: [AuthGuard, RoleGuard],
        data: { roles: [UserRole.Admin, UserRole.Moderator], title: 'titles.ingredientAssociation', description: 'meta.default.description' },
        loadComponent: () => import('./shared/components/pages/ingredient-association-page/ingredient-association-page.component').then((m) => m.IngredientAssociationPageComponent),
      },
      // Marketplace route — hidden until feature is deliverable
      // {
      //   path: 'marketplace',
      //   canActivate: [AuthGuard],
      //   data: { title: 'titles.marketplace', description: 'meta.default.description' },
      //   loadComponent: () => import('./shared/components/pages/marketplace-page/marketplace-page.component').then((m) => m.MarketplacePageComponent),
      // },
    ]
  },
  {
    path: '**',
    redirectTo: '', // Redirect invalid routes to English by default
  },
];
